import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModalService, SuiModal, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { WorkflowGroupAddModal } from '../workflow-group-add-modal/workflow-group-add-modal.component';
import { Subject } from 'rxjs';
interface IWorkflowGroupModalContext {
	data: any;
	title?: string;
	isEdit?: boolean;
}
@Component({
	selector: 'app-department-unit-modal',
	templateUrl: './project-new-modal.component.html',
	styleUrls: [ './project-new-modal.component.scss' ]
})
export class WorkflowGroupModalComponent implements OnInit, OnDestroy {
	searchable: boolean = true;
	public mode: DatepickerMode = 'year';
	public maxDate = new Date();
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;
	projectForm: FormGroup;
	units = [ { name: 'Unit 1' }, { name: 'Unit 2' }, { name: 'Unit 3' } ];
	groups: Array<any> = [];
	workFlow: any;
	constructor(
		private modalService: SuiModalService,
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<IWorkflowGroupModalContext, void, void>
	) {
		this.projectForm = fb.group({
			referenceNo: [ '' ],
			projectYear: [ '' ],
			procurement_type: [ '' ],
			selection_method: [ '' ],
			means_verfication: [ '' ],
			project_name: [ '' ],
			description: [ '' ],
			output_result: [ '' ]
		});
		this.workFlow = modal.context.data;
		this.groups = modal.context.data['workFlowGroups'];
	}
	isFieldValid(field: string) {
		return (
			(!this.projectForm.get(field).valid && this.projectForm.get(field).touched) ||
			(this.projectForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}
	save() {}
	// addGroup() {
	// 	let type: any = 'addunit';
	// 	this.modal.approve(type);
	// }
	editGroup(group) {
		this.modalService
			.open(
				new WorkflowGroupAddModal(
					`${this.modal.context.title}`,
					{ ...this.modal.context.data, ...{ selectedGroup: group } },
					true,
					ModalSize.Tiny
				)
			)
			.onApprove(() => {
				this.modal.approve(null);
			})
			.onDeny(() => {});
	}

	removeGroup(group) {
		for (let i = 0; i < this.groups.length; i++) {
			if (this.groups[i]['name'] == group['name']) {
				this.groups.splice(i, 0);
			}
		}
	}

	addGroup() {
		this.modalService
			.open(
				new WorkflowGroupAddModal(`${this.modal.context.title}`, this.modal.context.data, false, ModalSize.Tiny)
			)
			.onApprove(() => {
				this.modal.approve(null);
			})
			.onDeny(() => {});
	}

	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class WorkflowGroupModal extends ComponentModalConfig<IWorkflowGroupModalContext, void, void> {
	constructor(title: string, data: any, isEdit: boolean, size: ModalSize = ModalSize.Small) {
		super(WorkflowGroupModalComponent, { title, data, isEdit });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
